<vw-card customClasses="bg-white">
  <div class="p-4">
    <div class="flex items-start justify-between">
      <div class="flex-1 pr-2">
        <h3 class="truncate text-lg font-semibold text-[#023E42]">{{ bed.name }}</h3>
        <p class="text-xs text-[#9DA4A2]">{{ 'garden.beds.type.' + bed.type | translate }}</p>
      </div>
      <span class="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-[#6B7472]">{{ dimensionLabel }}</span>
    </div>

    <!-- Aperçu des cultures (mêmes carrés que partout, en plus petit) -->
    @if (count) {
      <div class="mt-3 flex gap-2">
        @for (c of previewCultures; track $index) {
          <div class="h-11 w-11">
            <vw-cultivation-item-viewer [cultivation]="$any(c)" displayType="SMALL"></vw-cultivation-item-viewer>
          </div>
        }
        @if (extraCount > 0) {
          <div class="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-200 text-sm text-white">+{{ extraCount }}</div>
        }
      </div>
    }

    <p class="mt-3 text-xs text-[#9DA4A2]">
      🌱 {{ 'garden.overview.cultures-count' | translate: { count: count } }} · {{ 'garden.overview.free-cells' | translate: { count: freeCells } }}
    </p>
  </div>
</vw-card>
